import state from './state';
import * as mutations from './mutations';
import * as actions from './actions';

export default {
    namespaced: true,
    mutations,
    actions,
    state
};



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales_budget_by_contacts_warehouses/index.js